export const getJson = json => {
  // console.log('getJson json:', json)
  handleNullHttpResponseMessage(json)
  json.httpResponseMessage.customReason = addCustomReason(json.httpResponseMessage)
  return json
}

// Handle calls (eg `/companiesHouse/search/' ) where there is 'currently' no httpResponseMessage - only statusCode and customReason
// See: Core.Models.CompaniesHouse.Search.CompanySearch.CompanySearchModel
const handleNullHttpResponseMessage = json => {
  // console.log('handleNullHttpResponseMessage json:', json)
  if (!!!json.httpResponseMessage)
    json.httpResponseMessage = {
      customReason: json.customReason,
      statusCode: json.statusCode,
    }
}

const addCustomReason = props => {
  // console.log('addCustomReason props:', props)
  const { statusCode, customReason } = props
  if (!!!customReason)
    switch (statusCode) {
      case 200: // OK
        return customReason

      case 404: // NotFound
        // test by using bad URL, e.g.
        // http://localhost:3000/company/13306068999/
        return "Oops! This page cannot be found"

      case 429: // Too Many Requests HTTP
        // test by running import all and get appointments at same time
        return "Data limit reached\nplease try again in 5 minutes"

      case 400: // BadRequest

      // test by using incorrect CH API key in appsettings.json 76
      case 401: // Unauthorized

      case 403: // Forbidden

      case 502: // Bad Gateway

      default:
        return "Uh-oh! Companies House server is not responding correctly😕\nPlease try again later."
    }
  else
    return customReason
}